import { useQuery } from '@tanstack/react-query';
import { MakesService } from '@/services/make/makesService';
import { GetAllMakesResponse } from '@/types/make';

export const useMakes = (enabled: boolean = true) => {
  const makesQuery = useQuery<GetAllMakesResponse, Error>({
    queryKey: ['makes'],
    queryFn: () => MakesService.getAllMakes(),
    enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
  });

  return {
    makes: makesQuery.data?.data || [],
    isLoadingMakes: makesQuery.isLoading,
    makesError: makesQuery.error,
    refetchMakes: makesQuery.refetch,
  };
};


